var EmergencyScenariosModal = (function (base) {
  __extends(EmergencyScenariosModal, base);


  function EmergencyScenariosModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  EmergencyScenariosModal.prototype.activate = function () {
    const self = this;

    this.loadContent('api/emergencies/scenarios')
      .then($modal => {

        $modal

          //Выбор вида ЧС
          .on('change', '#EmergencyTypeId', () => {
            var typeid = $('#EmergencyTypeId', $modal).val();

            $.ajax({
              url: Url.action('api/emergencies/scenarios/' + typeid),
              contentType: 'application/html; charset=utf-8',
              type: 'GET',
              dataType: 'html'
            })
              .done(result=> {
                $('.modal-content', $modal).html(result);
              });
          })

          // Добавление пункта в сценарий действий
          .on('click', '.scenario-add', function () {
            var $newScenario = $('#ScenarioNew', $modal);
            var typeid = $(this).data('emergensytypeid');

            self.apiClient.post('api/emergencies/scenarios/{0}/add'.format(typeid), { text: $newScenario.val() })
              .then(result => {
                if (result) {
                  var newScenario = '<div class="col-md-12 col-xs-12 m-b-sm">' +
                    '<a class="btn btn-xs btn-default m-b-xs scenario-delete" data-id="' + result.Id +
                    '" data-emergensytypeid="' + result.EmergencyTypeId +
                    '" data-text="' + result.Text +
                    '"><i class="fa fa-remove"></i> Удалить</a>' +
                    '<textarea class="commentary-modal-textarea scenario-text-js" cols="20" id="Text" name="Text" placeholder="Сценарий пока не задан" rows="3">' +
                    result.Text + '</textarea></div>';

                  var $scenarioContainer = $('#scenario-container', $modal)
                  $scenarioContainer.html($scenarioContainer.html() + newScenario);
                }
                $newScenario.val('');
              });
          })

          // Удаление пункта в сценарий действий
          .on('click', '.scenario-delete', function () {
            var typeid = $('#EmergencyTypeId', $modal).val();
            var $control = $(this);
            if (confirm('Вы действительно хотите удалить этот пункт сценария?')) {
              self.apiClient.post('api/emergencies/scenarios/{0}/del'.format($control.data('emergensytypeid')), {
                id: $control.data('id'),
                typeid: typeid,
                text: $control.data('text')
              })
              .then(result => {
                if (result) {
                  $control.parent().remove();
                }
              });
            }
          })

          // Сохранение сценария действий
          .on('click', '[js=save]', function () {
            const typeid = $('#EmergencyTypeId', $modal).val();
            const scenarioOfActions = [];
            $('#scenario-container .col-md-12.col-xs-12.m-b-sm').each(function(idx, emergency){
              scenarioOfActions.push({
                Id: $(emergency).children('a').data('id'),
                Text: $(emergency).children('textarea').val(),
                EmergencyTypeId: typeid
              });
            });

            self.apiClient.post('api/emergencies/scenarios', { emergencyTypeId: typeid, scenarioOfActions: scenarioOfActions, })
              .then(function (result) {
                if (result) {
                  self.close({ ok: true });
                }
              });
          });
      });
  };


  return EmergencyScenariosModal;
}(BaseModal));

